module.exports = __webpack_public_path__ + "static/img/logo.bb40a9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 221
// module chunks = 3